import React from "react";

const PaymentProgress = ({ prices }) => {
  if (!prices || prices.length === 0) {
    return (
      <p className="text-gray-600 text-center py-8">
        No payment plans available at this time.
      </p>
    );
  }

  return (
    <div className="bg-white border-2 border-gray-200 p-8">
      <div className="relative mb-8">
        <div className="absolute left-0 top-1/2 w-full h-1 bg-gray-300 -translate-y-1/2"></div>
        <div
          className="absolute left-0 top-1/2 h-1 bg-blue-500 -translate-y-1/2 transition-all duration-500"
          style={{ width: `${(100 / prices.length) * (prices.length - 1)}%` }} // Adjust based on how many steps completed/available
        ></div>{" "}
        {/* This is a visual filler, actual progress would be dynamic */}
        <div className="flex justify-between relative z-10">
          {prices.map((price, index) => (
            <div key={index} className="flex flex-col items-center">
              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xs border-2 border-white">
                {index + 1}
              </div>
              <div className="mt-3 text-sm font-semibold text-gray-800 uppercase text-center min-w-[80px]">
                {price.installment}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-12">
        {prices.map((price, index) => (
          <div
            key={index}
            className="flex justify-between items-center bg-gray-100 p-4 border-l-4 border-blue-500"
          >
            <span className="text-xl font-semibold text-gray-800 uppercase">
              {price.installment}
            </span>
            <span className="text-3xl font-bold text-blue-700">
              {price.percentage}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentProgress;
